import { FC, useEffect, useState } from 'react'
import { Button } from 'views/components/UI/Buttons'
import Input from 'views/components/UI/TextInput'
import { Card } from './styled'
import { disconnectMicrosoftSso, getMicrosoftSso, saveMicrosoftSso, startMicrosoftSso } from 'services/companies/microsoftSso'
import styled from 'styled-components'

const SsoCard = styled(Card)`
  background: #ffffff;
  border: 1px solid #e4ebf3;
  box-shadow: 0 12px 28px rgba(23, 55, 77, 0.08);
  border-radius: 18px;
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: auto;
  min-height: 210px;
  margin: 28px 0 0;
  padding: 24px 28px;
  cursor: default;

  &:hover {
    transform: none;
    border-color: #e4ebf3;
    box-shadow: 0 12px 28px rgba(23, 55, 77, 0.08);
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
`

const Title = styled.div`
  h3 { margin: 0 0 4px; font-size: 20px; color: #172b4d; }
  p { margin: 0; color: #718096; font-size: 14px; }
`

const Status = styled.span<{ active: boolean }>`
  padding: 7px 12px;
  border-radius: 16px;
  background: ${(props) => props.active ? '#e8f7ef' : '#fff4df'};
  color: ${(props) => props.active ? '#18794e' : '#9a6700'};
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`

const Fields = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  align-items: start;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
  @media (max-width: 600px) { flex-direction: column; }
`

const Activation = styled.label`
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 18px;
  color: #172b4d;
  font-size: 14px;
  font-weight: 600;
  input { width: 18px; height: 18px; accent-color: #c50070; }
`

const MicrosoftSsoSection: FC<{ companyId: number }> = ({ companyId }) => {
  const [tenantId, setTenantId] = useState('')
  const [domains, setDomains] = useState('')
  const [connected, setConnected] = useState(false)
  const [enabled, setEnabled] = useState(false)
  const [saveStatus, setSaveStatus] = useState<'idle' | 'saving' | 'success' | 'error'>('idle')
  useEffect(() => { getMicrosoftSso(companyId).then((config) => { setTenantId(config.microsoft_tenant_id || ''); setDomains(config.domains.join('\n')); setConnected(config.microsoft_sso_connected); setEnabled(config.microsoft_sso_enabled) }).catch(() => setSaveStatus('error')) }, [companyId])
  useEffect(() => { if (saveStatus === 'idle' || saveStatus === 'saving') return undefined; const timeout = window.setTimeout(() => setSaveStatus('idle'), 3000); return () => window.clearTimeout(timeout) }, [saveStatus])
  const save = async () => { setSaveStatus('saving'); try { const config = await saveMicrosoftSso(companyId, tenantId.trim(), domains.split(/[\n,]/).map((domain) => domain.trim().toLowerCase()).filter(Boolean), enabled); setConnected(config.microsoft_sso_connected); setEnabled(config.microsoft_sso_enabled); setSaveStatus('success') } catch { setSaveStatus('error') } }
  const connect = async () => window.location.assign(await startMicrosoftSso(companyId))
  const disconnect = async () => { try { const config = await disconnectMicrosoftSso(companyId); setConnected(config.microsoft_sso_connected); setEnabled(config.microsoft_sso_enabled); setSaveStatus('success') } catch { setSaveStatus('error') } }
  return <SsoCard><Header><Title><h3>Microsoft SSO</h3><p>Conecta esta empresa con su directorio Microsoft Entra.</p></Title><Status active={connected}>{connected ? 'Conexión activa' : 'Pendiente de consentimiento'}</Status></Header><Fields><Input type="text" label="Tenant ID de Microsoft Entra" value={tenantId} onChange={(event) => setTenantId(event.target.value)} placeholder="Ej.: 00000000-0000-0000-0000-000000000000" /><Input type="textarea" label="Dominios corporativos" value={domains} onChange={(event) => setDomains(event.target.value)} placeholder="Uno por línea" minRows={2} maxRows={3} /></Fields><Activation><input type="checkbox" checked={enabled} disabled={!connected} onChange={(event) => setEnabled(event.target.checked)} />Activar SSO</Activation><Actions><Button onClick={save} disabled={saveStatus === 'saving'}>{saveStatus === 'saving' ? 'Guardando…' : saveStatus === 'success' ? 'Guardado correctamente' : saveStatus === 'error' ? 'Error al guardar' : 'Guardar configuración'}</Button><Button onClick={connected ? disconnect : connect}>{connected ? 'Desconectar de Microsoft' : 'Conectar con Microsoft'}</Button></Actions></SsoCard>
}
export default MicrosoftSsoSection
